import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  pageTitlePSUser: {
    id: 'userprofile.pageTitlePSUser',
    nb: 'Praksisstedbruker',
    en: 'Practice place user',
  },
  pageTitleUHUser: {
    id: 'userprofile.pageTitleUHUser',
    nb: 'Studiestedbruker',
    en: 'Educational institution user',
  },
  titlePraksissted: {
    id: 'userprofile.titlePraksissted',
    nb: 'Praksisstedbruker - {institusjon}',
    en: 'Practice place user - {institusjon}',
  },
  titleStudent: {
    id: 'userprofile.titleStudent',
    nb: 'Student - {institusjon}',
    en: 'Student - {institusjon}',
  },
  titleStudiested: {
    id: 'userprofile.titleStudiested',
    nb: 'Studiestedbruker - {institusjon}',
    en: 'Educational institution user - {institusjon}',
  },
  subtitle: {
    id: 'userprofile.subtitle',
    nb: 'Brukerprofil hos Arbeidslivsportalen',
    en: 'User profile in Arbeidslivsportalen',
  },
  tilbake: {
    id: 'userprofile.tilbake',
    nb: 'Tilbake',
    en: 'Back',
  },
  avbryt: {
    id: 'userprofile.avbryt',
    nb: 'Avbryt',
    en: 'Cancel',
  },
  lagre: {
    id: 'userprofile.lagre',
    nb: 'Lagre',
    en: 'Save',
  },
  lagret: {
    id: 'userprofile.lagret',
    nb: 'Profil lagret',
    en: 'Profile saved',
  },
  giTilgang: {
    id: 'userprofile.giTilgang',
    nb: 'Legg til ny tilgang',
    en: 'Add privileges',
  },
  tilganger: {
    id: 'userprofile.tilganger',
    nb: 'Tilganger',
    en: 'Privileges',
  },
  tilgangerSubtitle: {
    id: 'userprofile.tilgangerSubtitle',
    nb: 'Velg tilgangsnivå og rettighet for brukeren',
    en: 'Select access level and permission for the user',
  },
  brukerrettighet: {
    id: 'userprofile.brukerrettighet',
    nb: 'Rettighet',
    en: 'Permission',
  },
  tilgangsnivaa: {
    id: 'userprofile.tilgangsnivaa',
    nb: 'Tilgangsnivå',
    en: 'Access level',
  },
  handling: {
    id: 'userprofile.handling',
    nb: 'Handling',
    en: 'Action',
  },
  rolleAdministrator: {
    id: 'userprofile.rolleAdministrator',
    nb: 'Administrator',
    en: 'Administrator',
  },
  rolleRegistrererettighet: {
    id: 'userprofile.rolleRegistrererettighet',
    nb: 'Registrererettighet',
    en: 'Registrererettighet',
  },
  rolleSkriverettighet: {
    id: 'userprofile.rolleSkriverettighet',
    nb: 'Skriverettighet',
    en: 'Write access',
  },
  rolleLeserettighet: {
    id: 'userprofile.rolleLeserettighet',
    nb: 'Leserettighet',
    en: 'Read access',
  },
  velgRolle: {
    id: 'userprofile.velgRolle',
    nb: 'Velg rettighet',
    en: 'Select permission',
  },
  velgTilgangsnivaa: {
    id: 'userprofile.velgTilgangsnivaa',
    nb: 'Velg tilgangsnivå',
    en: 'Select access level',
  },
  slett: {
    id: 'userprofile.slett',
    nb: 'Slett',
    en: 'Delete',
  },
  tilgangLagret: {
    id: 'userprofile.tilgangLagret',
    nb: 'Tilgang lagret',
    en: 'Privilege saved',
  },
  tilgangSlettet: {
    id: 'userprofile.tilgangerSlettet',
    nb: 'Tilgang slettet',
    en: 'Privilege deleted',
  },
  nyTilgang: {
    id: 'userprofile.nyTilgang',
    nb: 'Legg til tilgang',
    en: 'Add permission',
  },
  endre: {
    id: 'userprofile.endre',
    nb: 'Endre',
    en: 'Edit',
  },
  profileImgAltText: {
    id: 'userprofile.profileImgAltText',
    nb: 'Profilbilde',
    en: 'Profile picture',
  },
  fornavn: {
    id: 'userprofile.fornavn',
    nb: 'Fornavn',
    en: 'First name',
  },
  etternavn: {
    id: 'userprofile.etternavn',
    nb: 'Etternavn',
    en: 'Last name',
  },
  telefon: {
    id: 'userprofile.telefon',
    nb: 'Telefon',
    en: 'Phone',
  },
  epost: {
    id: 'userprofile.epost',
    nb: 'Epost',
    en: 'Email',
  },
  omMeg: {
    id: 'userprofile.omMeg',
    nb: 'Om meg',
    en: 'About me',
  },
  omMegHelpText: {
    id: 'userprofile.omMegHelpText',
    nb: 'I feltet "Om meg" ønsker vi følgende informasjon:',
    en: 'In the field "About me" we would like the following information:',
  },
  omMegHelpText1: {
    id: 'userprofile.omMegHelpText1',
    nb: 'Utdannelse, spesifiser om master',
    en: 'Education, specify if master degree',
  },
  omMegHelpText2: {
    id: 'userprofile.omMegHelpText2',
    nb: 'Pedagogisk kompetanse (antall studiepoeng)',
    en: 'Educational competence (number of credits)',
  },
  omMegHelpText3: {
    id: 'userprofile.omMegHelpText3',
    nb: 'Om kurs i studentveiledning',
    en: 'About courses in student supervision',
  },
  omMegHelpText4: {
    id: 'userprofile.omMegHelpText4',
    nb: 'Om du har vært veileder tidligere',
    en: 'If you have been a supervisor before',
  },
  activities: {
    id: 'userprofile.activities',
    nb: 'Praksisaktiviteter for studieåret {year}',
    en: 'Practice activities for the term {year}',
  },
  activititesSubtitleSelf: {
    id: 'userprofile.activititesSubtitleSelf',
    nb: 'Her finner du listen over alle brukerrollene du har for studieåret {year}',
    en: 'This list shows all the user roles you are assigned to for the term {year}',
  },
  activititesSubtitleUser: {
    id: 'userprofile.activititesSubtitleUser',
    nb: 'Her finner du listen over alle brukerrollene til {name} i studieåret {year}',
    en: 'This list shows all the user roles {name} are assigned to in the term {year}',
  },
  activitiesHeaderPeriod: {
    id: 'userprofile.activitiesHeaderPeriod',
    nb: 'Periode',
    en: 'Period',
  },
  activitiesHeaderType: {
    id: 'userprofile.activitiesHeaderType',
    nb: 'Praksistype',
    en: 'Practice type',
  },
  activitiesHeaderRole: {
    id: 'userprofile.activitiesHeaderRole',
    nb: 'Rolle',
    en: 'Role',
  },
  activitiesHeaderStatus: {
    id: 'userprofile.activitiesHeaderStatus',
    nb: 'Status',
    en: 'Status',
  },
  emptyPracticeActivitiesTitle: {
    id: 'userprofile.emptyPracticeActivitiesTitle',
    nb: '{name} har ingen aktive brukerroller i studieåret {year}',
    en: '{name} does not have any assigned user roles in the term {year}',
  },
  emptyPracticeActivitiesText: {
    id: 'userprofile.emptyPracticeActivities',
    nb: 'Det finnes ingen praksisaktiviteter å vise',
    en: "There's no practice activities to show",
  },
  toPracticeplaces: {
    id: 'userprofile.toPracticeplaces',
    nb: 'Til praksissteder',
    en: 'To practice places',
  },
  toInstitution: {
    id: 'userprofile.toInstitution',
    nb: 'Til studiesteder',
    en: 'To institution',
  },
  error: {
    id: 'userprofile.error',
    nb: 'Kunne ikke lagre, sjekk at informasjonen er riktig',
    en: 'Could not save, please make sure the information is correct',
  },
};

export default translations;
